<template>
    <v-dialog
        :model-value="dialog"
        v-if="dialog"
        width="800"
        persistent 
        :retain-focus="false">
        <v-card>
          <v-card-title>
            <h2>{{$t('Übersetzungen')}}</h2>
          </v-card-title>
        <v-card-text>
          <v-container>
            <v-expansion-panels>
                <v-expansion-panel v-if="translations.de">
                  <v-expansion-panel-title>DE</v-expansion-panel-title>
                  <v-expansion-panel-text>
                    <v-form
                      ref="firstForm"
                      v-model="valid"
                    >
                      <v-row>
                        <v-col cols="9">
                          <v-text-field
                              :label="$t('profil.de.name') + '*'"
                              v-model="translations.de.name"
                              required
                          ></v-text-field>
                        </v-col>
                      </v-row>
                    </v-form>
                  </v-expansion-panel-text>
                </v-expansion-panel>
                <v-expansion-panel v-if="translations.en">
                  <v-expansion-panel-title>EN</v-expansion-panel-title>
                  <v-expansion-panel-text>
                    <v-form
                      ref="firstForm"
                      v-model="valid"
                    >
                      <v-row>
                        <v-col cols="9">
                          <v-text-field
                              :label="$t('profil.en.name') + '*'"
                              v-model="translations.en.name"
                              required
                          ></v-text-field>
                        </v-col>
                      </v-row>
                    </v-form>
                  </v-expansion-panel-text>
                </v-expansion-panel>
              </v-expansion-panels>
            </v-container>
        </v-card-text>
        <v-card-actions>
            <v-spacer></v-spacer>

            <v-btn
              color="error"
              @click="no()"
              >
              {{$t('i18n_close')}}
            </v-btn>
            <v-btn
              color="primary"
              @click="sendTranslation()"
              >
              {{$t('i18n_save')}}
            </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
</template>

<script>
  import { mapState, mapActions } from "vuex";

  export default {
    props: {
      dialog: Boolean
    },
    data: () => ({
      isEditable: true,
      valid: true
    }),
    computed: {
      ...mapState({
        translations: state => state.configuration.texts
      })
    },
    methods: {
      ...mapActions('configuration', ['saveTranslation', 'deleteTranslation']),
      no() {
        this.$emit("fire-close", false);
      },
      sendTranslation() {
        this.saveTranslation(this.translations);
        this.$emit("fire-close", false);
      }
    }
  }
</script>